import React, { useState } from 'react';
import ReactModal from 'react-modal';
import './cartao-limite-modal.css';
import { FaArrowAltCircleDown, FaArrowAltCircleUp } from "react-icons/fa";
import { formatValueToMonetary } from '../../../utils/formatter';
import { toast } from 'react-toastify';
import { useCards } from '../../../hooks/useCards';

export const ModalLimite = ({ isOpen, onClose, card, fetchCardInfo }) => {
  const [limite, setLimite] = useState(card.contactlessUserLimit);
  const [updateLoader, setUpdateLoader] = useState(false);
  const maxLimite = card.contactlessMaxValue;

  const { updateCard } = useCards();

  const handleRangeChange = (event) => {
    setLimite(event.target.value);
  };

  const adjustLimite = (percent) => {
    let newLimite = Number(limite) + (card.contactlessMaxValue * percent);

    if (newLimite <= 0) {
      newLimite = 10;
    }

    setLimite(Math.min(Math.max(newLimite, 0), maxLimite));
  };

  const updateLimit = async () => {
    try {
      setUpdateLoader(true);
      const newLimit = limite;

      await updateCard({ contactlessUserLimit: newLimit, id: card.id });

      toast.success('Limite atualizado com sucesso!');

      onClose();
      fetchCardInfo();
    } catch (error) {
      console.log("error ", error);
      toast.error('Erro ao atualizar limite');
    } finally {
      setUpdateLoader(false);
    }
  }
  const rangeStyle = {
    background: `linear-gradient(to right, var(--ted-page-confirm-button-background) ${(limite / maxLimite) * 100
      }%, #ddd ${(limite / maxLimite) * 100}%)`,
  };

  return (
    <ReactModal
      isOpen={isOpen}
      className="change-modal"
      overlayClassName="overlay-change-password-modal"
    >
      <div className="modal-content" style={{ padding: '24px', borderRadius: '12px', maxWidth: '500px' }}>
        <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h5 style={{ fontWeight: 'bold' }}>Gerenciamento dos Limites</h5>
          <button className="btn-close" onClick={onClose}></button>
        </div>

        <div className="modal-body" style={{ marginTop: '16px' }}>
          <label style={{ fontSize: '14px', marginBottom: '4px', display: 'block' }}>Limite por Aproximação</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>

            <FaArrowAltCircleDown style={{ cursor: 'pointer', marginTop: '15px' }} onClick={() => adjustLimite(-0.1)} />
            <input
              type="range"
              min="0"
              max={maxLimite}
              value={limite}
              className="range-input"
              style={rangeStyle}
              onChange={handleRangeChange}
            />
            <FaArrowAltCircleUp style={{ cursor: 'pointer', marginTop: '15px' }} onClick={() => adjustLimite(0.1)} />

          </div>
          <div style={{ textAlign: 'center', marginTop: '8px', fontWeight: '500' }}>R$ {limite}</div>
        </div>

        <div className="modal-footer" style={{ marginTop: '24px', display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
          <button className="btn btn-outline-secondary" onClick={onClose}>Cancelar</button>
          <button className="btn btn-success" onClick={updateLimit}>Salvar</button>
        </div>
      </div>
    </ReactModal>
  );
};
